import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import SynonymRow from './SynonymRow';
import styles from '../../Synonyms.module.scss';
import tableStyles from 'components/kea/tables/DataTable.module.scss';

export const ManualSynonymsTable = ({
  synonyms,
  sortBy,
  sortOrder,
  onSort,
  onUpdate,
  onDelete,
  showValidationErrors = false,
}) => {
  const localizeMessage = useLocalizedMessage();
  const handleSort = (field) => {
    const isAsc = sortBy === field && sortOrder === 'asc';
    onSort({ sortBy: field, sortOrder: isAsc ? 'desc' : 'asc' });
  };
  const sortDirection = (field) => (sortBy === field ? sortOrder : false);
  const sortLabel = (field, label) => (
    <TableSortLabel
      active={sortBy === field}
      direction={sortBy === field ? sortOrder : 'asc'}
      onClick={() => handleSort(field)}
    >
      {label}
    </TableSortLabel>
  );

  return (
    <Table
      className={`${tableStyles.table} ${styles.table}`}
      aria-label={localizeMessage('search.page.customizationSynonyms.title')}
    >
      <TableHead className={styles.tableHead}>
        <TableRow>
          <TableCell sortDirection={sortDirection('left')}>
            {sortLabel('left', localizeMessage('search.synonyms.table.left'))}
          </TableCell>
          <TableCell className={styles.relationColumn}>
            <span className={styles.visuallyHidden}>
              {localizeMessage('search.synonyms.table.direction')}
            </span>
          </TableCell>
          <TableCell sortDirection={sortDirection('right')}>
            {sortLabel('right', localizeMessage('search.synonyms.table.right'))}
          </TableCell>
          <TableCell className={styles.statusColumn} sortDirection={sortDirection('enabled')}>
            {sortLabel('enabled', localizeMessage('search.synonyms.table.status'))}
          </TableCell>
          <TableCell className={styles.actionsColumn}>
            <span className={styles.visuallyHidden}>
              {localizeMessage('search.synonyms.table.actions')}
            </span>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {synonyms.map((synonym) => (
          <SynonymRow
            key={synonym._id}
            synonym={synonym}
            isHighlighted={Boolean(synonym._isNew)}
            shouldFocus={synonym._isNew && synonym._id === synonyms[0]?._id}
            onUpdate={onUpdate}
            onDelete={onDelete}
            showValidationErrors={showValidationErrors}
          />
        ))}
        {synonyms.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} className={styles.emptyState}>
              {localizeMessage('search.synonyms.empty')}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
